import React, { ChangeEvent } from "react";
import { twMerge } from "tailwind-merge";

interface ITextArea {
  id?: string;
  className?: string;
  placeholder?: string;
  label?: string;
  value?: string;
  // eslint-disable-next-line no-unused-vars
  onChange?: (e: ChangeEvent<any>) => void;
  // eslint-disable-next-line no-unused-vars
  onBlur?: (e: ChangeEvent<any>) => void;
  readonly?: boolean;
  disabled?: boolean;
  textColor?: string;
  rows?: number;
  required?: boolean;
  labelClassName?: string;
}

export function TextArea({
  id = "textarea",
  className = "",
  placeholder,
  label,
  value,
  onChange,
  onBlur,
  readonly = false,
  disabled = false,
  textColor = "text-dark-blue",
  rows,
  required,
  labelClassName,
}: ITextArea) {
  return (
    <div className={"flex flex-col items-start justify-center " + className}>
      <label className={twMerge("w-full text-gray-500 text-sm", labelClassName)} htmlFor={id}>
        {label}
        {required && <span className="text-red-500"> * </span>}
      </label>
      {!readonly ? (
        <textarea
          id={id}
          className="w-full rounded-md p-2 border"
          placeholder={placeholder}
          value={value}
          onChange={(e) => {
            onChange?.(e);
          }}
          onBlur={(e) => {
            onBlur?.(e);
          }}
          rows={rows}
          required={required}
          disabled={disabled}
        />
      ) : (
        <p className={"text-lg " + textColor}>{value || "-"}</p>
      )}
    </div>
  );
}
